export enum QuestionsOrder
{
    ByCriteria = 1,
    ByAlternatives = 2,
}

export enum SurveyVoteStatus
{
    Empty = 0,
    Agg = 1,
    Manual = 2
}

export class EstimationsVote
{
    QuestionId: string;
    ProjectUserId?: number;
    SurveyId?: number;
    Value?: number;
    Comment: string;
}


export class ScoreToAttributeValueMapping
{
    AlternativeId: string;
    AttributeId: number;
    HasDefinedAttributeValues: boolean;
    Score?: number;
    AttributeValue?: number;
    AttributeValueLabel?: string;
    IsExact: boolean;
}

export enum ConsistencyAnalysisStatus
{
    Unknown = 'Unknown',
    Consistent = 'Consistent',
    Acceptable = 'Acceptable',
    Inconsistent = 'Inconsistent'
}
